export const queryKeys = {
  session: ["polaris", "session"] as const,
  workspace: (slug: string) => ["polaris", slug, "bootstrap"] as const,
  leads: (slug: string, filters: object) => ["polaris", slug, "leads", filters] as const,
  lead: (slug: string, id: string) => ["polaris", slug, "lead", id] as const,
  today: (slug: string) => ["polaris", slug, "today"] as const,
  /** "Oggi" for one assignee filter (ADR 0063); `today` covers them all. */
  todayList: (slug: string, assignedTo: string | undefined) =>
    ["polaris", slug, "today", assignedTo ?? "all"] as const,
  /** Every calendar query: a week of one or all calendars, the reminders, the overlaps. */
  appointments: (slug: string) => ["polaris", slug, "appointments"] as const,
  /** Every memo list of the calendar (ADR 0076). */
  memos: (slug: string) => ["polaris", slug, "memos"] as const,
  memoList: (slug: string, memberId: string) => ["polaris", slug, "memos", memberId] as const,
  appointmentWeek: (slug: string, from: string, memberId: string) =>
    ["polaris", slug, "appointments", "week", from, memberId] as const,
  appointmentReminders: (slug: string) => ["polaris", slug, "appointments", "reminders"] as const,
  appointmentConflicts: (slug: string, slot: object) =>
    ["polaris", slug, "appointments", "conflicts", slot] as const,
  scheduledActions: (slug: string, leadId: string) =>
    ["polaris", slug, "lead", leadId, "scheduled-actions"] as const,
  scheduledMessages: (slug: string) => ["polaris", slug, "scheduled-messages"] as const,
  proposals: (slug: string) => ["polaris", slug, "proposals"] as const,
  proposalList: (slug: string, category: string, assignedTo: string | undefined) =>
    ["polaris", slug, "proposals", "list", category, assignedTo ?? "all"] as const,
  templates: (slug: string) => ["polaris", slug, "templates"] as const,
  whatsappCosts: (slug: string, month: string | null) =>
    ["polaris", slug, "whatsapp-costs", month] as const,
  apiCosts: (slug: string, month: string | null) => ["polaris", slug, "api-costs", month] as const,
  statistics: (slug: string, filters: object) => ["polaris", slug, "statistics", filters] as const,
  statisticsSources: (slug: string) => ["polaris", slug, "statistics-sources"] as const,
  /** Under the lead: a change of the lead refreshes its calls too. */
  leadApiUsage: (slug: string, leadId: string) =>
    ["polaris", slug, "lead", leadId, "api-usage"] as const,
  connectors: (slug: string) => ["polaris", slug, "connectors"] as const,
  members: (slug: string) => ["polaris", slug, "members"] as const,
  leadRouting: (slug: string) => ["polaris", slug, "lead-routing"] as const,
  dataJobs: (slug: string) => ["polaris", slug, "data-jobs"] as const,
  aiFeedbackSummary: (slug: string) => ["polaris", slug, "ai-feedback", "summary"] as const,
  aiHealth: (slug: string) => ["polaris", slug, "ai-health"] as const,
  /** Every wiki query: the tree, the pages, their revisions, the searches (ADR 0075). */
  wiki: (slug: string) => ["polaris", slug, "wiki"] as const,
  wikiTree: (slug: string) => ["polaris", slug, "wiki", "tree"] as const,
  wikiPage: (slug: string, pageId: string) => ["polaris", slug, "wiki", "page", pageId] as const,
  wikiRevisions: (slug: string, pageId: string) =>
    ["polaris", slug, "wiki", "revisions", pageId] as const,
  wikiSearch: (slug: string, query: string) => ["polaris", slug, "wiki", "search", query] as const,
  proposalSources: (slug: string, proposalId: string) =>
    ["polaris", slug, "proposal-sources", proposalId] as const,
  proposalSourcesToday: (slug: string, proposalId: string) =>
    ["polaris", slug, "proposal-sources", proposalId, "today"] as const,
  proposalSourcesExamples: (slug: string, proposalId: string) =>
    ["polaris", slug, "proposal-sources", proposalId, "examples"] as const,
};
